import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './Style.css';
import ApiSender from '../../common/ApiLogic';
import useLanguage from '../../common/useLanguage';
import {
  SUPPORT_EMAIL,
  UNSUB_LINK,
  SELFCARE_APP_NAME,
  CALL_CENTER_USSD,
  MANAGE_USSD,
  COMPANY_NAME,
  COMPANY_LOCATION,
} from '../../common/constants';
import Header from './components/Header';
import SiteFooter from './components/Footer';

function TermsPage() {
  const location = useLocation();
  const apiSender = useMemo(() => new ApiSender(), []);
  const { language, selectLanguage, t } = useLanguage(location, apiSender);

  return (
    <div className="Ks-page">
      <Header language={language} onSelectLanguage={selectLanguage} />

      <div className="legal-page">
        <h1>{t('Условия использования', 'Колдонуу шарттары', 'Terms of Use')}</h1>

        {language === 'RU' ? (
          <>
            <p>
              Настоящие условия регулируют оформление и использование подписки на сервис родительского контроля
              Kid Security («Сервис»), предоставляемой абонентам оператора Mega (Кыргызская Республика)
              посредством прямого списания средств со счёта абонента (DCB).
            </p>

            <h3>1. Тарифные планы</h3>
            <ul>
              <li>KS_Daily — 6 сом в день</li>
              <li>KS_Monthly — 80 сом в месяц</li>
              <li>KS_Yearly — 800 сом в год</li>
            </ul>
            <p>
              Каждому новому подписчику предоставляется 3 дня бесплатного пробного периода при подключении любого
              из тарифов. По окончании пробного периода подписка автоматически продлевается на выбранных условиях,
              и с лицевого счёта абонента списывается стоимость выбранного тарифа. Подписка продлевается
              автоматически до момента отмены.
            </p>

            <h3>2. Кто может подписаться</h3>
            <p>
              Услуга доступна активным абонентам Mega. Оформляя подписку, вы подтверждаете, что вам исполнилось
              18 лет, либо подписка оформляется с согласия родителя или законного представителя.
            </p>

            <h3>3. Отмена подписки</h3>
            <p>Отменить подписку можно в любой момент одним из следующих способов:</p>
            <ul>
              <li>в личном кабинете — приложение {SELFCARE_APP_NAME};</li>
              <li>по звонку в контакт-центр: {CALL_CENTER_USSD};</li>
              <li>по USSD-команде управления подпиской: {MANAGE_USSD};</li>
              <li>на странице отмены подписки: <a href={UNSUB_LINK} target="_blank" rel="noopener noreferrer">{UNSUB_LINK}</a>.</li>
            </ul>

            <h3>4. Изменение условий</h3>
            <p>
              Оператор Сервиса вправе изменять тарифы и условия подписки, уведомив пользователей заблаговременно
              на этой странице. Продолжение использования Сервиса после вступления изменений в силу означает
              согласие с обновлёнными условиями.
            </p>

            <h3>5. Ограничение ответственности</h3>
            <p>
              Сервис предоставляется «как есть». Оператор Сервиса не несёт ответственности за косвенные убытки,
              возникшие в результате использования или невозможности использования Сервиса, в пределах,
              допустимых применимым законодательством.
            </p>

            <h3>6. Контакты</h3>
            <p>
              По любым вопросам, связанным с подпиской, пишите на <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
            </p>
            <p>
              Оператор Сервиса: {COMPANY_NAME}, {COMPANY_LOCATION}.
            </p>
          </>
        ) : language === 'KY' ? (
          <>
            <p>
              Бул шарттар Mega (Кыргыз Республикасы) операторунун абоненттерине абонттун эсебинен түз
              эсептен алуу (DCB) аркылуу берилүүчү Kid Security ата-эне көзөмөл кызматына («Кызмат») жазылууну
              жана аны колдонууну жөнгө салат.
            </p>

            <h3>1. Тарифтик пландар</h3>
            <ul>
              <li>KS_Daily — күнүнө 6 сом</li>
              <li>KS_Monthly — айына 80 сом</li>
              <li>KS_Yearly — жылына 800 сом</li>
            </ul>
            <p>
              Ар бир жаңы жазылуучуга каалаган тарифке туташканда 3 күн бекер сынак мезгили берилет. Сынак
              мезгили аяктагандан кийин жазылуу тандалган шарттарда автоматтык түрдө узартылат жана абонттун
              эсебинен тандалган тарифтин наркы эсептен алынат. Жазылуу жокко чыгарылганга чейин автоматтык
              түрдө узартылып турат.
            </p>

            <h3>2. Ким жазыла алат</h3>
            <p>
              Кызмат Mega-дун активдүү абоненттерине жеткиликтүү. Жазылуу менен сиз 18 жашка толгонуңузду,
              же жазылуу ата-эненин же мыйзамдуу өкүлдүн уруксаты менен жасалганын тастыктайсыз.
            </p>

            <h3>3. Жазылуудан баш тартуу</h3>
            <p>Жазылууну каалаган убакта төмөнкү жолдордун бири менен жокко чыгарууга болот:</p>
            <ul>
              <li>жеке кабинетте — {SELFCARE_APP_NAME} колдонмосу;</li>
              <li>байланыш борборуна чалуу: {CALL_CENTER_USSD};</li>
              <li>жазылууну башкаруу боюнча USSD-командасы: {MANAGE_USSD};</li>
              <li>жазылуудан баш тартуу баракчасында: <a href={UNSUB_LINK} target="_blank" rel="noopener noreferrer">{UNSUB_LINK}</a>.</li>
            </ul>

            <h3>4. Шарттардын өзгөрүшү</h3>
            <p>
              Кызматтын операторы колдонуучуларды алдын ала бул баракчада эскертүү менен тарифтерди жана
              жазылуу шарттарын өзгөртүү укугуна ээ. Өзгөртүүлөр күчүнө киргенден кийин Кызматты андан ары
              колдонуу жаңыланган шарттар менен макулдугуңузду билдирет.
            </p>

            <h3>5. Жоопкерчиликти чектөө</h3>
            <p>
              Кызмат «болгон бойдон» берилет. Кызматтын операторы Кызматты колдонуудан же колдонуу
              мүмкүн болбогондуктан келип чыккан кыйыр зыяндар үчүн, колдонуудагы мыйзамдарда уруксат
              берилген чекте, жооп бербейт.
            </p>

            <h3>6. Байланыш</h3>
            <p>
              Жазылууга байланыштуу бардык суроолор боюнча <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> дарегине жазыңыз.
            </p>
            <p>
              Кызматтын оператору: {COMPANY_NAME}, {COMPANY_LOCATION}.
            </p>
          </>
        ) : (
          <>
            <p>
              These terms govern signing up for and using the Kid Security parental control subscription
              (the "Service"), offered to subscribers of the Mega operator (Kyrgyz Republic) through direct
              carrier billing (DCB).
            </p>

            <h3>1. Subscription plans</h3>
            <ul>
              <li>KS_Daily — 6 KGS per day</li>
              <li>KS_Monthly — 80 KGS per month</li>
              <li>KS_Yearly — 800 KGS per year</li>
            </ul>
            <p>
              Every new subscriber gets a 3-day free trial on any plan. Once the trial ends, the subscription
              renews automatically under the chosen terms and the price of the selected plan is charged to the
              subscriber's account. The subscription keeps renewing automatically until cancelled.
            </p>

            <h3>2. Who can subscribe</h3>
            <p>
              The service is available to active Mega subscribers. By subscribing, you confirm that you are
              18 years of age or older, or that the subscription is made with the consent of a parent or legal
              guardian.
            </p>

            <h3>3. Cancelling the subscription</h3>
            <p>You can cancel the subscription at any time using one of the following methods:</p>
            <ul>
              <li>in your self-service account — the {SELFCARE_APP_NAME} app;</li>
              <li>by calling the contact center: {CALL_CENTER_USSD};</li>
              <li>via the subscription-management USSD code: {MANAGE_USSD};</li>
              <li>on the cancellation page: <a href={UNSUB_LINK} target="_blank" rel="noopener noreferrer">{UNSUB_LINK}</a>.</li>
            </ul>

            <h3>4. Changes to these terms</h3>
            <p>
              The Service operator may change plans and subscription terms by giving advance notice on this
              page. Continuing to use the Service after changes take effect means you accept the updated terms.
            </p>

            <h3>5. Limitation of liability</h3>
            <p>
              The Service is provided "as is". The Service operator is not liable for indirect losses arising
              from the use or inability to use the Service, to the extent permitted by applicable law.
            </p>

            <h3>6. Contact</h3>
            <p>
              For any questions related to the subscription, write to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
            </p>
            <p>
              Service operator: {COMPANY_NAME}, {COMPANY_LOCATION}.
            </p>
          </>
        )}
      </div>

      <SiteFooter t={t} language={language} />
    </div>
  );
}

export default TermsPage;
